'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './user-directory.routes';

export class UserDirectoryComponent {
  constructor(User, DTOptionsBuilder, $state, Config, Auth) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "User Directory");
    this.Auth = Auth;

    this.permissions = Config.getModuleConfig(Config.Modules.Profile).getPermissions();
    this.useShortAddr = Config.getModuleConfig(Config.Modules.Profile).getUseShortAddressFormat();
    this.buildingAsAddress = Config.getModuleConfig(Config.Modules.Directories).getBuildingAsAddress();

    this.displayRoles = Config.getModuleConfig(Config.Modules.Profile).getUserDirectoryDisplayRoles();

    this.permissions = Config.getModuleConfig(Config.Modules.Directories).getPermissions();

    this.Auth.getCurrentUser(user => {

      this.userRoles = user.role;
      
      if (!this.permissions["user-directory-export"]
        || (this.permissions["user-directory-export"] && this.permissions["user-directory-export"].some(role => this.userRoles.includes(role)) ) ) {

        this.dtOptions = DTOptionsBuilder.newOptions()
          .withOption('dom', 'lBfrtip')
          .withOption('responsive', true)
          .withOption('order', [0, 'asc'])
          .withOption('buttons',[{
            extend: 'excel',
            title: 'User Directory'
          },{
            extend: 'csv',
            title: 'User Directory'
          },{
            title: 'User Directory',
            message: 'As of ' + moment().format("MMMM Do YYYY"),
            extend: 'pdf',
            orientation: 'landscape',
            pageSize: 'LETTER'
          },'print']);
      } else {
        this.dtOptions = DTOptionsBuilder.newOptions()
          .withOption('dom', 'lfrtip')
          .withOption('responsive', true)
          .withOption('order', [0, 'asc']);
      }

      User.query(users => {
        this.data = users.filter(user => user.role.some(r => this.displayRoles.includes(r))
          && !user.role.includes("superadmin")
          && !user.role.includes("system"));
      });
    })
  }

  formatAddress(adr) {
    if (this.useShortAddr && adr.type != 'Other') {

      return adr.street;


    } else {

      let oAdr = [];

      oAdr.push(adr.street);
      oAdr.push("<br/>");
      if (adr.street2) {
        oAdr.push(adr.street2);
        oAdr.push("<br/>");
      }
      oAdr.push(adr.city);
      oAdr.push(", ");
      oAdr.push(adr.state);
      oAdr.push(" ");
      oAdr.push(adr.zip);
      if (adr.country) {
        oAdr.push("<br/>");
        oAdr.push(adr.country);
      }

      return oAdr.join("");

    }
  }

  hasPermission(field) {
    if (!this.permissions.hasOwnProperty(field))
      return true;

    return this.Auth.getCurrentUserSync().role.some(r => this.permissions[field].includes(r));
  }
}

export default angular.module('conduuApp.userDirectory', [uiRouter])
  .config(routes)
  .component('userDirectory', {
    template: require('./user-directory.html'),
    controller: UserDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/user/user-directory.component.js